import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/app/homepage/components/FeaturedProjects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/app/homepage/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/node_modules/next/dist/client/link.js");
